<template>
  <div class="pa-4">
    <h1>
      aggrid筛选
    </h1>
    <ag-grid-vue
      :grid-options="gridOptions"
      style="height: 350px;"
      class="ag-theme-alpine"
      :column-defs="columnDefs"
      :row-data="rowData"
      :pagination="true"
      :pagination-auto-page-size="false"
      :pagination-page-size="paginationPageSize"
      @first-data-rendered="onFirstDataRendered"
      @filterChanged="onFilterChanged"
    />
    <div>
      <p>手写的一个分页:</p>
      <div
        class="d-flex align-center"
        :style="`height: 32px;`"
      >
        <div class="mr-2">
          每页行数:
        </div>
        <div>
          <v-select
            v-model="paginationPageSize"
            outlined
            dense
            :items="paginationPageSizeOptions"
            small
            hide-details
            class="ag-select align-self-center"
            style="max-width: min-content;"
            @change="onPageSizeChanged"
          />
        </div>
        <v-spacer />
        <div class="mt-2 d-flex">
          <v-pagination
            v-model="curPage"
            :length="totalPages"
            :total-visible="7"
            color="primary"
            @input="onPaginationInput"
          />
          <div class="agText ag-rightWidth ml-6 d-flex align-center">
            <span class="mr-1">第</span>
            <v-text-field
              v-model="curPageText"
              style="min-width: fit-content;"
              outlined
              dense
              hide-details
            />
            <span class="ml-1">页</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridVue } from "ag-grid-vue";

LicenseManager.setLicenseKey('CompanyName=Suzhou ruhlamat Smart Technologies Co., Ltd.,LicensedApplication=Infinity,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=30,AssetReference=AG-030422,SupportServicesEnd=30_August_2023_[v2]_MTY5MzM1MDAwMDAwMA==28423dd515d527503fc5a257dc86a8ac');

export default {
  name: "Aggrid",
  components: {
    AgGridVue,
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      gridOptions: {
        defaultColDef: {
          sortable: true,
          filter: true,
          resizable: true,
          floatingFilter: true,
          minWidth: 200,
          flex: 1,
        },
      },
      paginationPageSize: 2, // 每页n个
      paginationPageSizeOptions: [
        { text: '2', value: 2 },
        { text: '4', value: 4 },
        { text: '10', value: 10 },
        { text: '100', value: 100 },
        { text: 'All', value: 0 },
      ],
      totalRecords: 0, // 总条数
      curPage: 1, // 当前页码
      totalPages: 0, // 总页码
    };
  },
  computed: {
    curPageText: {
      get() {
        return this.curPage;
      },
      set(val) {
        if (!Number(val)) {
          this.gridApi.paginationGoToPage(0);
          this.curPage = 1;
        } else if (Number(val) > this.totalPages) {
          this.gridApi.paginationGoToPage(this.totalPages - 1);
          this.curPage = this.totalPages;
        } else {
          this.gridApi.paginationGoToPage(Number(val) - 1);
          this.curPage = Number(val);
        }
      },
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        field: "make",
        filter: 'agTextColumnFilter',
      },
      {
        field: "model",
        // filter: 'agTextColumnFilter',
      },
      {
        field: "price",
        filter: 'agNumberColumnFilter',
      },
    ];

    this.rowData = [
      { make: "1Toyota", model: "Celica", price: 35000 },
      { make: "2Ford", model: "Mondeo", price: 32000 },
      { make: "3Porsche", model: "Boxster", price: 72000 },
      { make: "4Toyota", model: "Celica", price: 35000 },
      { make: "5Ford", model: "Mondeo", price: 32000 },
      { make: "6Porsche", model: "Boxster", price: 72000 },
      { make: "7Toyota", model: "Celica", price: 35000 },
      { make: "8Ford", model: "Mondeo", price: 32000 },
      { make: "9Porsche", model: "Boxster", price: 72000 },
      { make: "10Toyota", model: "Celica", price: 35000 },
      { make: "11Ford", model: "Mondeo", price: 32000 },
      { make: "12Porsche", model: "Boxster", price: 72000 },
      { make: "13Toyota", model: "Celica", price: 35000 },
      { make: "14Ford", model: "Mondeo", price: 32000 },
      { make: "15Porsche", model: "Boxster", price: 72000 },
      { make: "16Toyota", model: "Celica", price: 35000 },
      { make: "17Ford", model: "Mondeo", price: 32000 },
      { make: "18Porsche", model: "Boxster", price: 72000 },
    ];
    this.initPagination(this.rowData);

  },
  methods: {
    // 初始化api
    onFirstDataRendered(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    // 筛选条件修改方法
    onFilterChanged() {
      // 重新计算分页
      const tableRows = this.gridApi.getModel().rowsToDisplay;
      this.initPagination(tableRows);
      // 页码超出重置当前页码
      if (this.totalPages < this.curPage) {
        console.log(this.curPage, this.totalPages, 'go to last');
        this.curPage = this.totalPages;
        this.onPaginationInput(this.curPage);
      }
    },
    onPageSizeChanged() {
      // 重新计算分页
      const tableRows = this.gridApi.getModel().rowsToDisplay;
      this.initPagination(tableRows);
      // 页码超出重置当前页码
      if (this.totalPages < this.curPage) {
        console.log(this.curPage, this.totalPages, 'go to last');
        this.curPage = this.totalPages;
        this.onPaginationInput(this.curPage);
      }
    },
    // 重新加载分页总数
    initPagination(rowData) {
      this.totalRecords = rowData.length || 0;
      if (rowData.length && this.paginationPageSize) {
        this.totalPages = Math.ceil(rowData.length / this.paginationPageSize);
      } else {
        this.totalPages = 0;
      }
    },
    onPaginationInput(page) {
      // aggrid的第一页是0
      this.gridApi.paginationGoToPage(page - 1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";
</style>